/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RequestSetItem } from './RequestSetItem';
import {
    RequestSetItemFromJSON,
    RequestSetItemFromJSONTyped,
    RequestSetItemToJSON,
    RequestSetItemToJSONTyped,
} from './RequestSetItem';

/**
 * 
 * @export
 * @interface RequestUpdateAmazonItemsRequest
 */
export interface RequestUpdateAmazonItemsRequest {
    /**
     * 実出荷単位数
     * @type {number}
     * @memberof RequestUpdateAmazonItemsRequest
     */
    actualShippingNum?: number;
    /**
     * Amazon商品名
     * @type {string}
     * @memberof RequestUpdateAmazonItemsRequest
     */
    amazonItemName: string;
    /**
     * 納品数
     * @type {number}
     * @memberof RequestUpdateAmazonItemsRequest
     */
    arriveCount: number;
    /**
     * 
     * @type {string}
     * @memberof RequestUpdateAmazonItemsRequest
     */
    asin: string;
    /**
     * 
     * @type {number}
     * @memberof RequestUpdateAmazonItemsRequest
     */
    baseId: number;
    /**
     * 
     * @type {number}
     * @memberof RequestUpdateAmazonItemsRequest
     */
    cellerBaseId?: number;
    /**
     * 
     * @type {number}
     * @memberof RequestUpdateAmazonItemsRequest
     */
    cellerUserId?: number;
    /**
     * 
     * @type {string}
     * @memberof RequestUpdateAmazonItemsRequest
     */
    deliveryUnit: string;
    /**
     * 
     * @type {number}
     * @memberof RequestUpdateAmazonItemsRequest
     */
    destructionNum?: number;
    /**
     * セットがない場合に必須項目
     * @type {number}
     * @memberof RequestUpdateAmazonItemsRequest
     */
    expectedCount?: number;
    /**
     * セットなし時の賞味期限
     * @type {string}
     * @memberof RequestUpdateAmazonItemsRequest
     */
    expiryDate?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestUpdateAmazonItemsRequest
     */
    fnsku: string;
    /**
     * 
     * @type {number}
     * @memberof RequestUpdateAmazonItemsRequest
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof RequestUpdateAmazonItemsRequest
     */
    imageUrl?: string;
    /**
     * セラー要確認商品の登録かどうかのフラグ
     * @type {boolean}
     * @memberof RequestUpdateAmazonItemsRequest
     */
    isNeedConfimationItem: boolean;
    /**
     * JANコード
     * @type {string}
     * @memberof RequestUpdateAmazonItemsRequest
     */
    jan?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestUpdateAmazonItemsRequest
     */
    memo?: string;
    /**
     * 
     * @type {number}
     * @memberof RequestUpdateAmazonItemsRequest
     */
    returnNum?: number;
    /**
     * Amazonセット数
     * @type {number}
     * @memberof RequestUpdateAmazonItemsRequest
     */
    setCount: number;
    /**
     * セット情報（1セット＝1行）
     * @type {Array<RequestSetItem>}
     * @memberof RequestUpdateAmazonItemsRequest
     */
    setItems?: Array<RequestSetItem>;
    /**
     * 
     * @type {string}
     * @memberof RequestUpdateAmazonItemsRequest
     */
    sku: string;
    /**
     * 
     * @type {number}
     * @memberof RequestUpdateAmazonItemsRequest
     */
    status: number;
    /**
     * 
     * @type {number}
     * @memberof RequestUpdateAmazonItemsRequest
     */
    stickerNum?: number;
    /**
     * 保管場所
     * @type {string}
     * @memberof RequestUpdateAmazonItemsRequest
     */
    storageLocation?: string;
    /**
     * 
     * @type {number}
     * @memberof RequestUpdateAmazonItemsRequest
     */
    sumNum?: number;
    /**
     * 
     * @type {number}
     * @memberof RequestUpdateAmazonItemsRequest
     */
    tenantId: number;
    /**
     *
     * @type {number}
     * @memberof RequestUpdateAmazonItemsRequest
     */
    userId: number;
    /**
     * 実際に操作したユーザーのID（管理者など）
     * @type {number}
     * @memberof RequestUpdateAmazonItemsRequest
     */
    operatorUserId?: number;
}

/**
 * Check if a given object implements the RequestUpdateAmazonItemsRequest interface.
 */
export function instanceOfRequestUpdateAmazonItemsRequest(value: object): value is RequestUpdateAmazonItemsRequest {
    if (!('amazonItemName' in value) || value['amazonItemName'] === undefined) return false;
    if (!('arriveCount' in value) || value['arriveCount'] === undefined) return false;
    if (!('asin' in value) || value['asin'] === undefined) return false;
    if (!('baseId' in value) || value['baseId'] === undefined) return false;
    if (!('deliveryUnit' in value) || value['deliveryUnit'] === undefined) return false;
    if (!('fnsku' in value) || value['fnsku'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('isNeedConfimationItem' in value) || value['isNeedConfimationItem'] === undefined) return false;
    if (!('setCount' in value) || value['setCount'] === undefined) return false;
    if (!('sku' in value) || value['sku'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('tenantId' in value) || value['tenantId'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    return true;
}

export function RequestUpdateAmazonItemsRequestFromJSON(json: any): RequestUpdateAmazonItemsRequest {
    return RequestUpdateAmazonItemsRequestFromJSONTyped(json, false);
}

export function RequestUpdateAmazonItemsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestUpdateAmazonItemsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'actualShippingNum': json['actual_shipping_num'] == null ? undefined : json['actual_shipping_num'],
        'amazonItemName': json['amazon_item_name'],
        'arriveCount': json['arrive_count'],
        'asin': json['asin'],
        'baseId': json['base_id'],
        'cellerBaseId': json['celler_base_id'] == null ? undefined : json['celler_base_id'],
        'cellerUserId': json['celler_user_id'] == null ? undefined : json['celler_user_id'],
        'deliveryUnit': json['delivery_unit'],
        'destructionNum': json['destruction_num'] == null ? undefined : json['destruction_num'],
        'expectedCount': json['expected_count'] == null ? undefined : json['expected_count'],
        'expiryDate': json['expiry_date'] == null ? undefined : json['expiry_date'],
        'fnsku': json['fnsku'],
        'id': json['id'],
        'imageUrl': json['image_url'] == null ? undefined : json['image_url'],
        'isNeedConfimationItem': json['is_need_confimation_item'],
        'jan': json['jan'] == null ? undefined : json['jan'],
        'memo': json['memo'] == null ? undefined : json['memo'],
        'returnNum': json['return_num'] == null ? undefined : json['return_num'],
        'setCount': json['set_count'],
        'setItems': json['set_items'] == null ? undefined : ((json['set_items'] as Array<any>).map(RequestSetItemFromJSON)),
        'sku': json['sku'],
        'status': json['status'],
        'stickerNum': json['sticker_num'] == null ? undefined : json['sticker_num'],
        'storageLocation': json['storage_location'] == null ? undefined : json['storage_location'],
        'sumNum': json['sum_num'] == null ? undefined : json['sum_num'],
        'tenantId': json['tenant_id'],
        'userId': json['user_id'],
        'operatorUserId': json['operator_user_id'] == null ? undefined : json['operator_user_id'],
    };
}

export function RequestUpdateAmazonItemsRequestToJSON(json: any): RequestUpdateAmazonItemsRequest {
    return RequestUpdateAmazonItemsRequestToJSONTyped(json, false);
}

export function RequestUpdateAmazonItemsRequestToJSONTyped(value?: RequestUpdateAmazonItemsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'actual_shipping_num': value['actualShippingNum'],
        'amazon_item_name': value['amazonItemName'],
        'arrive_count': value['arriveCount'],
        'asin': value['asin'],
        'base_id': value['baseId'],
        'celler_base_id': value['cellerBaseId'],
        'celler_user_id': value['cellerUserId'],
        'delivery_unit': value['deliveryUnit'],
        'destruction_num': value['destructionNum'],
        'expected_count': value['expectedCount'],
        'expiry_date': value['expiryDate'],
        'fnsku': value['fnsku'],
        'id': value['id'],
        'image_url': value['imageUrl'],
        'is_need_confimation_item': value['isNeedConfimationItem'],
        'jan': value['jan'],
        'memo': value['memo'],
        'return_num': value['returnNum'],
        'set_count': value['setCount'],
        'set_items': value['setItems'] == null ? undefined : ((value['setItems'] as Array<any>).map(RequestSetItemToJSON)),
        'sku': value['sku'],
        'status': value['status'],
        'sticker_num': value['stickerNum'],
        'storage_location': value['storageLocation'],
        'sum_num': value['sumNum'],
        'tenant_id': value['tenantId'],
        'user_id': value['userId'],
        'operator_user_id': value['operatorUserId'],
    };
}

